export default __webpack_public_path__ + "4986a2de1a36e78b424f40776eeb0806.png";